import {useFundamentalsLanguage} from '@hconnect/common/hooks'
import {BackendFile, ControlledDragAndDropFiles} from '@hm/fundamental'

export type AttachmentFile = File | BackendFile

type DragAndDropFilesProps = {
  initialValue: AttachmentFile[]
  onChange: (files: AttachmentFile[]) => void
  onRemoveFile: (fileId: string) => void
  multiple?: boolean
  hint?: string
  error?: string
  touched?: boolean
  className?: string
}

export const DragAndDropFiles = ({
  initialValue = [],
  onChange,
  onRemoveFile,
  multiple = true,
  hint,
  error,
  touched,
  className
}: DragAndDropFilesProps) => {
  const language = useFundamentalsLanguage()

  return (
    <ControlledDragAndDropFiles
      data-cy="drag-and-drop-files-attachmentFiles"
      value={initialValue}
      onChange={onChange}
      onRemoveBackendFile={onRemoveFile}
      multiple={multiple}
      hint={hint}
      error={error}
      touched={touched}
      className={className}
      language={language}
      name="attachmentFiles"
    />
  )
}
